import React, { useEffect, useState } from "react";
import CelebrationScreen from "../Celebration/CelebrationScreen";
import NarrativeCompletionCard from "../widgets/Module6/Steps Building Narrative/NarrativeCompletionCard";
import { progressService } from "../../../../services/progressService";

const NarrativeCelebration = ({ userId, subsectionId, onNextStep }) => {
  const [cardData, setCardData] = useState(null);

  useEffect(() => {
    async function loadNarrative() {
      try {
        const progress = await progressService.getUserProgress(
          userId,
          subsectionId
        );

        // narrative lives under payload.selectedCard (+ bullets/tagline already stored)
        const payload = progress?.data?.payload || progress?.data;
        const savedCard = payload?.selectedCard;

        if (savedCard) {
          setCardData(savedCard);
        }
      } catch (err) {
        console.error("Error loading narrative completion data:", err);
      }
    }

    if (userId && subsectionId) {
      loadNarrative();
    }
  }, [userId, subsectionId]);

  if (!cardData) return <div className="p-10">Loading...</div>;

  // map savedCard into CompletionCard props
  const cardProps = {
    heroTitle: cardData.name || "My Narrative",
    heroSubtitle: cardData.tagline || "",
    bullets: Array.isArray(cardData.bullets) ? cardData.bullets : [],
  };

  return (
    <CelebrationScreen
      title="Kudos on reaching the 5th milestone in your journey – Building Your Narrative"
      subtitle=""
      theme="meeting_personality"
      onNext={onNextStep}
      hideBack={true}
      fullScreen={true}
    >
      <NarrativeCompletionCard {...cardProps} />
    </CelebrationScreen>
  );
};

export default NarrativeCelebration;
